import { useRef, useState, useEffect } from "react";
import AOS from "aos";
import React from "react"
import Step1 from "./step-one"
import Step2 from "./step-two"
import Step3 from "./step-three"
import Step4 from "./step-four"


const Steps = () => {
  const leftDivRef = useRef(null);
  const stepOneImg = `${process.env.PUBLIC_URL}/assets/img/step-one-img.png`
  const stepTwoImg = `${process.env.PUBLIC_URL}/assets/img/step-two-img.png`
  const stepThreeImg = `${process.env.PUBLIC_URL}/assets/img/step-four-img.png`
  const stepFourImg = `${process.env.PUBLIC_URL}/assets/img/step-three-img.png`
  const [imgSource, setImgSrc] = useState(stepOneImg);
  const OneDisplay = () =>  (<div>
    <h1>Apply Online</h1>
    <p>Select your desired loan amount and review the repayment schedule and costs. If you are happy with your loan terms, submit electronically and we'll do the rest for you.</p>
  </div>)
  const TwoDisplay = () =>  (<div>
    <h1>Register & Verify <br/>Employment</h1>
    <p>We will verify your employment. Employment verification is automated and it takes one click and only a few minutes for your loan and monthly repayment to be approved by your employer.</p>
  </div>)
  const ThreeDisplay = () => (<div>
    <h1>Repayments</h1>
    <p>Typically, repayments are set up automatically through your payroll by your employer. But with some employers, employees are asked to set up repayments on their own through card payment, direct debit or post dated cheques.</p>
  </div>)
  const FourDisplay = () =>(<div>
    <h1>"Instant" Cash</h1>
    <p>Your funds are disbursed electronically into your salary account same day.</p>
  </div>)

const Display = () =>{
  if(imgSource === stepOneImg){
    return(
      <OneDisplay/>
    )
  }else if(imgSource === stepTwoImg){
    return(
      <TwoDisplay/>
    )
  }else if(imgSource === stepThreeImg){
    return(
      <ThreeDisplay/>
    )
  }else if(imgSource === stepFourImg){
    return(
      <FourDisplay/>
    )
  }else{
    return(
      <OneDisplay/>
    )
  }
}


  useEffect(() => {
    AOS.init({
        duration: 1000,
      });
    
  }, [imgSource]);

  


      const handleScroll = (e) => {
        const leftDiv = leftDivRef.current;

        if (leftDiv) {
          const scrollTop = 0 - leftDiv.getBoundingClientRect().top;
          console.log(leftDiv.getBoundingClientRect().top)
          if (window.innerWidth > 600 && scrollTop < 800) {
            setImgSrc(stepOneImg);
          } else if (window.innerWidth > 600 && scrollTop < 1400) {
            setImgSrc(stepTwoImg);
          } else if (window.innerWidth > 600 && scrollTop < 2200) {
            setImgSrc(stepThreeImg);
          }else if (window.innerWidth > 600 && scrollTop < 3000) {
            setImgSrc(stepFourImg);
          }else  if (window.innerWidth <= 600 && scrollTop < -500) {
            setImgSrc(stepOneImg);
          } else if (window.innerWidth <= 600 && scrollTop < 500) {
            setImgSrc(stepTwoImg);
          } else if (window.innerWidth <= 600 && scrollTop < 1000) {
            setImgSrc(stepThreeImg);
          }else if (window.innerWidth <= 600 && scrollTop < 1500) {
            setImgSrc(stepFourImg);
          }
        }
      };

      window.addEventListener("scroll", handleScroll);

      const stages = [{id: "1", img: stepOneImg},{id: "2", img: stepTwoImg}, {id: "3", img: stepThreeImg}, {id: "4", img: stepFourImg}]

    return(
        <div className="step-container">
         <div className="title"><h1>How does it work?</h1></div> 
        <div className="step-animation-div">
        <div className="left">
            <div className="img-indicator">
          <div className="display-phone2">
         <Display/>
         </div>
        <img src={imgSource} alt="img"/>
        <div className="indicator-container">
            {stages.map(i => (
                <div key={i.id} className={i.img === imgSource ? "active-indicator": "indicator"}></div>
            ))}
        </div>
        </div>
        </div>
        <div ref={leftDivRef}>
       <Step1/>
       <Step2/>
       <Step3/>
       <Step4/>
       </div>
        </div>
        </div>
    )
}

export default Steps